import { V1Head } from "src/pages/reports/ffi/v1/types";

export const meta: Record<V1Head, Opportunity> = {
    sinsAreForgiven: {
        title: "My sins are forgiven because Jesus died for me",
        prologue: "",
    },
    createdInTheImageOfGod: {
        title: "All people are created in the image of God",
        prologue: "",
    },
    inspiredWordOfGod: {
        title: "The Bible is the inspired Word of God",
        prologue: "",
    },
    jesusChristIsMyLoad: {
        title: "Jesus Christ is my Lord and Savior",
        prologue: "",
    },
    marriageIsBetweenAManAndAWoman: {
        title: "The Bible teaches that marriage is between one man and one woman",
        prologue: "",
    },
    fatherSonHolySpirit: {
        title: "There is one God who exists in three persons—Father, Son, and Holy Spirit",
        prologue: "",
    },
    sexOutsideOfMarriageIsSin: {
        title: "Sex outside of marriage is sin",
        prologue: "",
    },
    jesusIsSonOfGod: {
        title: "Jesus Christ is the Son of God",
        prologue: "",
    },
    hopeForEternalLife: {
        title: "My only hope for eternal life is in the finished work of Jesus Christ",
        prologue: "",
    },
    jesusIsGodAndMan: {
        title: "Jesus Christ is both fully God and fully man",
        prologue: "",
    },
    realHeaven: {
        title: "There is a real heaven where those who are saved through faith in Christ will live with God forever",
        prologue: "",
    },
    jesusConductedMiracles: {
        title: "Jesus conducted miracles",
        prologue: "",
    },
    sinceTheFall: {
        title: "Since the Fall, people are born in sin and have a natural tendency toward evil",
        prologue: "",
    },
    jesusWasBornOfAVirgin: {
        title: "Jesus was born of a virgin",
        prologue: "",
    },
    godCreatedEverything: {
        title: "God created everything that exists without any help",
        prologue: "",
    },
    jesusLiveASinlessLife: {
        title: "Jesus lived a perfect, sinless life",
        prologue: "",
    },
    salvationIsOnlyPossibleThroughJesus: {
        title: "Salvation is only possible through faith in Jesus Christ",
        prologue: "",
    },
    jesusDiedOnTheCross: {
        title: "Jesus Christ died on the cross",
        prologue: "",
    },
    bibleIsTheStandardForFaith: {
        title: "The Bible is our only standard for faith and living",
        prologue: "",
    },
    jesusRoseFromTheDead: {
        title: "Jesus Christ rose bodily on the third day from the grave",
        prologue: "",
    },
    churchWasEstablishedByGod: {
        title: "The church was established by God, and Jesus is the head of the church",
        prologue: "",
    },
    jesusWillReturn: {
        title: "Jesus Christ will return someday in power and glory",
        prologue: "",
    },
    godContinuesToBeInvolvedInTheWorld: {
        title: "God continues to be involved in his creation, protecting and providing for his people",
        prologue: "",
    },
    godHatesSin: {
        title: "God hates sin",
        prologue: "",
    },
    christiansAreCommanded: {
        title: "Christians are commanded to love God with all their heart, soul, mind, and strength",
        prologue: "",
    },
};
